import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { UserInfo } from '../interfaces/user-info.interface';

export interface AuthenticationState {
  userInfo: UserInfo | null;
  accessToken: string | null;
  expiresAt: string | null;
  mfaVerified: boolean;
}

export function createInitialState(): AuthenticationState {
  return {
    userInfo: null,
    accessToken: null,
    expiresAt: null,
    mfaVerified: false  
  };
}

@StoreConfig({ name: 'Authentication' })
@Injectable({ providedIn: 'root' })
export class AuthenticationStore extends Store<AuthenticationState> {
  constructor() {
    super(createInitialState());
  }
}
